"use strict";

var _objectSpread = require("/codebuild/output/src51269578/src/codestar-connections.us-west-2.amazonaws.com/git-http/646102706174/us-west-2/a9a51b65-2233-41be-8487-b400c0b14934/amplify-education/web-assessment-dashboard/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _asyncToGenerator2 = require("/codebuild/output/src51269578/src/codestar-connections.us-west-2.amazonaws.com/git-http/646102706174/us-west-2/a9a51b65-2233-41be-8487-b400c0b14934/amplify-education/web-assessment-dashboard/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function unwrapExports(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function createCommonjsModule(e, t) {
  return e(t = {
    exports: {}
  }, t.exports), t.exports;
}
Object.defineProperty(exports, "__esModule", {
  value: !0
});
var asyncToGenerator = createCommonjsModule(function (e) {
    function t(e, t, r, n, o, a, i) {
      try {
        var s = e[a](i),
          c = s.value;
      } catch (e) {
        return void r(e);
      }
      s.done ? t(c) : Promise.resolve(c).then(n, o);
    }
    e.exports = function (e) {
      return function () {
        var r = this,
          n = arguments;
        return new Promise(function (o, a) {
          var i = e.apply(r, n);
          function s(e) {
            t(i, o, a, s, c, "next", e);
          }
          function c(e) {
            t(i, o, a, s, c, "throw", e);
          }
          s(void 0);
        });
      };
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }),
  _asyncToGenerator = unwrapExports(asyncToGenerator),
  classCallCheck = createCommonjsModule(function (e) {
    e.exports = function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }),
  _classCallCheck = unwrapExports(classCallCheck),
  _typeof_1 = createCommonjsModule(function (e) {
    function t(r) {
      return e.exports = t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      }, e.exports.__esModule = !0, e.exports.default = e.exports, t(r);
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  });
unwrapExports(_typeof_1);
var toPrimitive = createCommonjsModule(function (e) {
  var t = _typeof_1.default;
  e.exports = function (e, r) {
    if ("object" !== t(e) || null === e) return e;
    var n = e[Symbol.toPrimitive];
    if (void 0 !== n) {
      var o = n.call(e, r || "default");
      if ("object" !== t(o)) return o;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(e);
  }, e.exports.__esModule = !0, e.exports.default = e.exports;
});
unwrapExports(toPrimitive);
var toPropertyKey = createCommonjsModule(function (e) {
  var t = _typeof_1.default;
  e.exports = function (e) {
    var r = toPrimitive(e, "string");
    return "symbol" === t(r) ? r : String(r);
  }, e.exports.__esModule = !0, e.exports.default = e.exports;
});
unwrapExports(toPropertyKey);
var createClass = createCommonjsModule(function (e) {
    function t(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, toPropertyKey(n.key), n);
      }
    }
    e.exports = function (e, r, n) {
      return r && t(e.prototype, r), n && t(e, n), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }),
  _createClass = unwrapExports(createClass),
  regeneratorRuntime$1 = createCommonjsModule(function (e) {
    var t = _typeof_1.default;
    function r() {
      e.exports = r = function r() {
        return n;
      }, e.exports.__esModule = !0, e.exports.default = e.exports;
      var n = {},
        o = Object.prototype,
        a = o.hasOwnProperty,
        i = Object.defineProperty || function (e, t, r) {
          e[t] = r.value;
        },
        s = "function" == typeof Symbol ? Symbol : {},
        c = s.iterator || "@@iterator",
        u = s.asyncIterator || "@@asyncIterator",
        p = s.toStringTag || "@@toStringTag";
      function l(e, t, r) {
        return Object.defineProperty(e, t, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), e[t];
      }
      try {
        l({}, "");
      } catch (e) {
        l = function l(e, t, r) {
          return e[t] = r;
        };
      }
      function f(e, t, r, n) {
        var o = t && t.prototype instanceof v ? t : v,
          a = Object.create(o.prototype),
          s = new B(n || []);
        return i(a, "_invoke", {
          value: D(e, r, s)
        }), a;
      }
      function h(e, t, r) {
        try {
          return {
            type: "normal",
            arg: e.call(t, r)
          };
        } catch (e) {
          return {
            type: "throw",
            arg: e
          };
        }
      }
      n.wrap = f;
      var d = {};
      function v() {}
      function y() {}
      function m() {}
      var g = {};
      l(g, c, function () {
        return this;
      });
      var w = Object.getPrototypeOf,
        x = w && w(w(C([])));
      x && x !== o && a.call(x, c) && (g = x);
      var b = m.prototype = v.prototype = Object.create(g);
      function _(e) {
        ["next", "throw", "return"].forEach(function (t) {
          l(e, t, function (e) {
            return this._invoke(t, e);
          });
        });
      }
      function E(e, r) {
        var n;
        i(this, "_invoke", {
          value: function value(o, i) {
            function s() {
              return new r(function (n, s) {
                !function n(o, i, s, c) {
                  var u = h(e[o], e, i);
                  if ("throw" !== u.type) {
                    var p = u.arg,
                      l = p.value;
                    return l && "object" == t(l) && a.call(l, "__await") ? r.resolve(l.__await).then(function (e) {
                      n("next", e, s, c);
                    }, function (e) {
                      n("throw", e, s, c);
                    }) : r.resolve(l).then(function (e) {
                      p.value = e, s(p);
                    }, function (e) {
                      return n("throw", e, s, c);
                    });
                  }
                  c(u.arg);
                }(o, i, n, s);
              });
            }
            return n = n ? n.then(s, s) : s();
          }
        });
      }
      function D(e, t, r) {
        var n = "suspendedStart";
        return function (o, a) {
          if ("executing" === n) throw new Error("Generator is already running");
          if ("completed" === n) {
            if ("throw" === o) throw a;
            return T();
          }
          for (r.method = o, r.arg = a;;) {
            var i = r.delegate;
            if (i) {
              var s = M(i, r);
              if (s) {
                if (s === d) continue;
                return s;
              }
            }
            if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
              if ("suspendedStart" === n) throw n = "completed", r.arg;
              r.dispatchException(r.arg);
            } else "return" === r.method && r.abrupt("return", r.arg);
            n = "executing";
            var c = h(e, t, r);
            if ("normal" === c.type) {
              if (n = r.done ? "completed" : "suspendedYield", c.arg === d) continue;
              return {
                value: c.arg,
                done: r.done
              };
            }
            "throw" === c.type && (n = "completed", r.method = "throw", r.arg = c.arg);
          }
        };
      }
      function M(e, t) {
        var r = t.method,
          n = e.iterator[r];
        if (void 0 === n) return t.delegate = null, "throw" === r && e.iterator.return && (t.method = "return", t.arg = void 0, M(e, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), d;
        var o = h(n, e.iterator, t.arg);
        if ("throw" === o.type) return t.method = "throw", t.arg = o.arg, t.delegate = null, d;
        var a = o.arg;
        return a ? a.done ? (t[e.resultName] = a.value, t.next = e.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, d) : a : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, d);
      }
      function L(e) {
        var t = {
          tryLoc: e[0]
        };
        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
      }
      function k(e) {
        var t = e.completion || {};
        t.type = "normal", delete t.arg, e.completion = t;
      }
      function B(e) {
        this.tryEntries = [{
          tryLoc: "root"
        }], e.forEach(L, this), this.reset(!0);
      }
      function C(e) {
        if (e) {
          var t = e[c];
          if (t) return t.call(e);
          if ("function" == typeof e.next) return e;
          if (!isNaN(e.length)) {
            var r = -1,
              n = function t() {
                for (; ++r < e.length;) if (a.call(e, r)) return t.value = e[r], t.done = !1, t;
                return t.value = void 0, t.done = !0, t;
              };
            return n.next = n;
          }
        }
        return {
          next: T
        };
      }
      function T() {
        return {
          value: void 0,
          done: !0
        };
      }
      return y.prototype = m, i(b, "constructor", {
        value: m,
        configurable: !0
      }), i(m, "constructor", {
        value: y,
        configurable: !0
      }), y.displayName = l(m, p, "GeneratorFunction"), n.isGeneratorFunction = function (e) {
        var t = "function" == typeof e && e.constructor;
        return !!t && (t === y || "GeneratorFunction" === (t.displayName || t.name));
      }, n.mark = function (e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, m) : (e.__proto__ = m, l(e, p, "GeneratorFunction")), e.prototype = Object.create(b), e;
      }, n.awrap = function (e) {
        return {
          __await: e
        };
      }, _(E.prototype), l(E.prototype, u, function () {
        return this;
      }), n.AsyncIterator = E, n.async = function (e, t, r, o, a) {
        void 0 === a && (a = Promise);
        var i = new E(f(e, t, r, o), a);
        return n.isGeneratorFunction(t) ? i : i.next().then(function (e) {
          return e.done ? e.value : i.next();
        });
      }, _(b), l(b, p, "Generator"), l(b, c, function () {
        return this;
      }), l(b, "toString", function () {
        return "[object Generator]";
      }), n.keys = function (e) {
        var t = Object(e),
          r = [];
        for (var n in t) r.push(n);
        return r.reverse(), function e() {
          for (; r.length;) {
            var n = r.pop();
            if (n in t) return e.value = n, e.done = !1, e;
          }
          return e.done = !0, e;
        };
      }, n.values = C, B.prototype = {
        constructor: B,
        reset: function reset(e) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(k), !e) for (var t in this) "t" === t.charAt(0) && a.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
        },
        stop: function stop() {
          this.done = !0;
          var e = this.tryEntries[0].completion;
          if ("throw" === e.type) throw e.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(e) {
          if (this.done) throw e;
          var t = this;
          function r(r, n) {
            return i.type = "throw", i.arg = e, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
          }
          for (var n = this.tryEntries.length - 1; n >= 0; --n) {
            var o = this.tryEntries[n],
              i = o.completion;
            if ("root" === o.tryLoc) return r("end");
            if (o.tryLoc <= this.prev) {
              var s = a.call(o, "catchLoc"),
                c = a.call(o, "finallyLoc");
              if (s && c) {
                if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                if (this.prev < o.finallyLoc) return r(o.finallyLoc);
              } else if (s) {
                if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
              } else {
                if (!c) throw new Error("try statement without catch or finally");
                if (this.prev < o.finallyLoc) return r(o.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(e, t) {
          for (var r = this.tryEntries.length - 1; r >= 0; --r) {
            var n = this.tryEntries[r];
            if (n.tryLoc <= this.prev && a.call(n, "finallyLoc") && this.prev < n.finallyLoc) {
              var o = n;
              break;
            }
          }
          o && ("break" === e || "continue" === e) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
          var i = o ? o.completion : {};
          return i.type = e, i.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, d) : this.complete(i);
        },
        complete: function complete(e, t) {
          if ("throw" === e.type) throw e.arg;
          return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), d;
        },
        finish: function finish(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var r = this.tryEntries[t];
            if (r.finallyLoc === e) return this.complete(r.completion, r.afterLoc), k(r), d;
          }
        },
        catch: function _catch(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var r = this.tryEntries[t];
            if (r.tryLoc === e) {
              var n = r.completion;
              if ("throw" === n.type) {
                var o = n.arg;
                k(r);
              }
              return o;
            }
          }
          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, t, r) {
          return this.delegate = {
            iterator: C(e),
            resultName: t,
            nextLoc: r
          }, "next" === this.method && (this.arg = void 0), d;
        }
      }, n;
    }
    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  });
unwrapExports(regeneratorRuntime$1);
var runtime = regeneratorRuntime$1(),
  regenerator = runtime;
try {
  regeneratorRuntime = runtime;
} catch (e) {
  "object" == typeof globalThis ? globalThis.regeneratorRuntime = runtime : Function("r", "regeneratorRuntime = r")(runtime);
}
var instanceOfAny = function instanceOfAny(e, t) {
  return t.some(function (t) {
    return e instanceof t;
  });
};
var idbProxyableTypes, cursorAdvanceMethods;
function getIdbProxyableTypes() {
  return idbProxyableTypes || (idbProxyableTypes = [IDBDatabase, IDBObjectStore, IDBIndex, IDBCursor, IDBTransaction]);
}
function getCursorAdvanceMethods() {
  return cursorAdvanceMethods || (cursorAdvanceMethods = [IDBCursor.prototype.advance, IDBCursor.prototype.continue, IDBCursor.prototype.continuePrimaryKey]);
}
var cursorRequestMap = new WeakMap(),
  transactionDoneMap = new WeakMap(),
  transactionStoreNamesMap = new WeakMap(),
  transformCache = new WeakMap(),
  reverseTransformCache = new WeakMap();
function promisifyRequest(e) {
  var t = new Promise(function (t, r) {
    var n = function n() {
        e.removeEventListener("success", o), e.removeEventListener("error", a);
      },
      o = function o() {
        t(wrap(e.result)), n();
      },
      a = function a() {
        r(e.error), n();
      };
    e.addEventListener("success", o), e.addEventListener("error", a);
  });
  return t.then(function (t) {
    t instanceof IDBCursor && cursorRequestMap.set(t, e);
  }).catch(function () {}), reverseTransformCache.set(t, e), t;
}
function cacheDonePromiseForTransaction(e) {
  if (transactionDoneMap.has(e)) return;
  var t = new Promise(function (t, r) {
    var n = function n() {
        e.removeEventListener("complete", o), e.removeEventListener("error", a), e.removeEventListener("abort", a);
      },
      o = function o() {
        t(), n();
      },
      a = function a() {
        r(e.error || new DOMException("AbortError", "AbortError")), n();
      };
    e.addEventListener("complete", o), e.addEventListener("error", a), e.addEventListener("abort", a);
  });
  transactionDoneMap.set(e, t);
}
var idbProxyTraps = {
  get: function get(e, t, r) {
    if (e instanceof IDBTransaction) {
      if ("done" === t) return transactionDoneMap.get(e);
      if ("objectStoreNames" === t) return e.objectStoreNames || transactionStoreNamesMap.get(e);
      if ("store" === t) return r.objectStoreNames[1] ? void 0 : r.objectStore(r.objectStoreNames[0]);
    }
    return wrap(e[t]);
  },
  set: function set(e, t, r) {
    return e[t] = r, !0;
  },
  has: function has(e, t) {
    return e instanceof IDBTransaction && ("done" === t || "store" === t) || t in e;
  }
};
function replaceTraps(e) {
  idbProxyTraps = e(idbProxyTraps);
}
function wrapFunction(e) {
  return e !== IDBDatabase.prototype.transaction || "objectStoreNames" in IDBTransaction.prototype ? getCursorAdvanceMethods().includes(e) ? function () {
    for (var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++) {
      t[_key] = arguments[_key];
    }
    return e.apply(unwrap(this), t), wrap(cursorRequestMap.get(this));
  } : function () {
    for (var _len2 = arguments.length, t = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      t[_key2] = arguments[_key2];
    }
    return wrap(e.apply(unwrap(this), t));
  } : function (t) {
    for (var _len3 = arguments.length, r = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      r[_key3 - 1] = arguments[_key3];
    }
    var n = e.call.apply(e, [unwrap(this), t].concat(r));
    return transactionStoreNamesMap.set(n, t.sort ? t.sort() : [t]), wrap(n);
  };
}
function transformCachableValue(e) {
  return "function" == typeof e ? wrapFunction(e) : (e instanceof IDBTransaction && cacheDonePromiseForTransaction(e), instanceOfAny(e, getIdbProxyableTypes()) ? new Proxy(e, idbProxyTraps) : e);
}
function wrap(e) {
  if (e instanceof IDBRequest) return promisifyRequest(e);
  if (transformCache.has(e)) return transformCache.get(e);
  var t = transformCachableValue(e);
  return t !== e && (transformCache.set(e, t), reverseTransformCache.set(t, e)), t;
}
var unwrap = function unwrap(e) {
  return reverseTransformCache.get(e);
};
function openDB(e, t) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    r = _ref.blocked,
    n = _ref.upgrade,
    o = _ref.blocking,
    a = _ref.terminated;
  var i = indexedDB.open(e, t),
    s = wrap(i);
  return n && i.addEventListener("upgradeneeded", function (e) {
    n(wrap(i.result), e.oldVersion, e.newVersion, wrap(i.transaction));
  }), r && i.addEventListener("blocked", function () {
    return r();
  }), s.then(function (e) {
    a && e.addEventListener("close", function () {
      return a();
    }), o && e.addEventListener("versionchange", function () {
      return o();
    });
  }).catch(function () {}), s;
}
var readMethods = ["get", "getKey", "getAll", "getAllKeys", "count"],
  writeMethods = ["put", "add", "delete", "clear"],
  cachedMethods = new Map();
function getMethod(e, t) {
  if (!(e instanceof IDBDatabase) || t in e || "string" != typeof t) return;
  if (cachedMethods.get(t)) return cachedMethods.get(t);
  var r = t.replace(/FromIndex$/, ""),
    n = t !== r,
    o = writeMethods.includes(r);
  if (!(r in (n ? IDBIndex : IDBObjectStore).prototype) || !o && !readMethods.includes(r)) return;
  var a = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator2( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
      var _i;
      var a,
        i,
        _len4,
        t,
        _key4,
        s,
        _args = arguments;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            a = this.transaction(e, o ? "readwrite" : "readonly");
            i = a.store;
            for (_len4 = _args.length, t = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
              t[_key4 - 1] = _args[_key4];
            }
            n && (i = i.index(t.shift()));
            _context.next = 6;
            return (_i = i)[r].apply(_i, t);
          case 6:
            s = _context.sent;
            _context.t0 = o;
            if (!_context.t0) {
              _context.next = 11;
              break;
            }
            _context.next = 11;
            return a.done;
          case 11:
            return _context.abrupt("return", s);
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    return function a(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  return cachedMethods.set(t, a), a;
}
replaceTraps(function (e) {
  return _objectSpread({}, e, {
    get: function get(t, r, n) {
      return getMethod(t, r) || e.get(t, r, n);
    },
    has: function has(t, r) {
      return !!getMethod(t, r) || e.has(t, r);
    }
  });
});
var DEFAULT_DB_VERSION = 1,
  DEFAULT_OBJ_STORE_NAME = "key_value_storage",
  IndexedDBClient = function () {
    function e(t) {
      var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : DEFAULT_DB_VERSION,
        n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : DEFAULT_OBJ_STORE_NAME;
      _classCallCheck(this, e), this.name = t, this.version = r, this.objectStoreName = n, this.connection = null;
    }
    return _createClass(e, [{
      key: "openDB",
      value: function () {
        var e = _asyncToGenerator(regenerator.mark(function e() {
          var t, r, n;
          return regenerator.wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                if (this.connection) {
                  e.next = 15;
                  break;
                }
                return e.prev = 1, t = this.objectStoreName, r = this.name, n = this.version, e.t0 = openDB, e.t1 = r, e.t2 = n, e.t3 = {
                  upgrade: function upgrade(e) {
                    e.createObjectStore(t);
                  },
                  blocked: function blocked() {
                    throw new Error("DB ".concat(r, " v").concat(n, " is blocked by another connection to DB of older version"));
                  },
                  blocking: function blocking() {
                    throw new Error("DB ".concat(r, " v").concat(n, " is blocking another connection to DB of future version"));
                  },
                  terminated: function terminated() {
                    throw new Error("DB ".concat(r, " v").concat(n, " was closed unexpectedly"));
                  }
                }, e.next = 9, (0, e.t0)(e.t1, e.t2, e.t3);
              case 9:
                this.connection = e.sent, e.next = 15;
                break;
              case 12:
                throw e.prev = 12, e.t4 = e.catch(1), new Error("Failed to open DB: ".concat(this.name, " v").concat(this.version, ". Error: ").concat(e.t4));
              case 15:
                return e.abrupt("return", this.connection);
              case 16:
              case "end":
                return e.stop();
            }
          }, e, this, [[1, 12]]);
        }));
        return function () {
          return e.apply(this, arguments);
        };
      }()
    }, {
      key: "getItem",
      value: function () {
        var e = _asyncToGenerator(regenerator.mark(function e(t) {
          var r;
          return regenerator.wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return e.next = 2, this.openDB();
              case 2:
                return r = e.sent, e.abrupt("return", r.get(this.objectStoreName, t));
              case 4:
              case "end":
                return e.stop();
            }
          }, e, this);
        }));
        return function (t) {
          return e.apply(this, arguments);
        };
      }()
    }, {
      key: "setItem",
      value: function () {
        var e = _asyncToGenerator(regenerator.mark(function e(t, r) {
          var n;
          return regenerator.wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return e.next = 2, this.openDB();
              case 2:
                return n = e.sent, e.abrupt("return", n.put(this.objectStoreName, r, t));
              case 4:
              case "end":
                return e.stop();
            }
          }, e, this);
        }));
        return function (t, r) {
          return e.apply(this, arguments);
        };
      }()
    }, {
      key: "removeItem",
      value: function () {
        var e = _asyncToGenerator(regenerator.mark(function e(t) {
          var r;
          return regenerator.wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return e.next = 2, this.openDB();
              case 2:
                return r = e.sent, e.abrupt("return", r.delete(this.objectStoreName, t));
              case 4:
              case "end":
                return e.stop();
            }
          }, e, this);
        }));
        return function (t) {
          return e.apply(this, arguments);
        };
      }()
    }, {
      key: "clear",
      value: function () {
        var e = _asyncToGenerator(regenerator.mark(function e() {
          var t;
          return regenerator.wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return e.next = 2, this.openDB();
              case 2:
                return t = e.sent, e.abrupt("return", t.clear(this.objectStoreName));
              case 4:
              case "end":
                return e.stop();
            }
          }, e, this);
        }));
        return function () {
          return e.apply(this, arguments);
        };
      }()
    }, {
      key: "getAllKeys",
      value: function () {
        var e = _asyncToGenerator(regenerator.mark(function e() {
          var t;
          return regenerator.wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return e.next = 2, this.openDB();
              case 2:
                return t = e.sent, e.abrupt("return", t.getAllKeys(this.objectStoreName));
              case 4:
              case "end":
                return e.stop();
            }
          }, e, this);
        }));
        return function () {
          return e.apply(this, arguments);
        };
      }()
    }]), e;
  }(),
  ENGLISH = "eng",
  DIBELS8 = "dibels8",
  IDEL2 = "idel2",
  BENCHMARK_WINDOW_KEY = "benchmark_window",
  BMWindowClient = function () {
    function e() {
      _classCallCheck(this, e), this.assessmentDBStorage = new IndexedDBClient("assessment");
    }
    return _createClass(e, [{
      key: "getBenchmarkWindow",
      value: function () {
        var e = _asyncToGenerator(regenerator.mark(function e() {
          var t;
          return regenerator.wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return e.next = 2, this.assessmentDBStorage.getItem(BENCHMARK_WINDOW_KEY);
              case 2:
                return t = e.sent, e.abrupt("return", JSON.parse(t.value));
              case 4:
              case "end":
                return e.stop();
            }
          }, e, this);
        }));
        return function () {
          return e.apply(this, arguments);
        };
      }()
    }, {
      key: "getAppPeriodData",
      value: function () {
        var e = _asyncToGenerator(regenerator.mark(function e(t, r, n) {
          var o, a;
          return regenerator.wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return o = this.constructor.getAppByLanguage(t, n), e.next = 3, this.getBenchmarkWindow();
              case 3:
                return a = e.sent, e.abrupt("return", Object.values(a).filter(function (e) {
                  return e.app === o && e.period === r;
                }));
              case 5:
              case "end":
                return e.stop();
            }
          }, e, this);
        }));
        return function (t, r, n) {
          return e.apply(this, arguments);
        };
      }()
    }, {
      key: "isCurrentDayInPeriod",
      value: function () {
        var e = _asyncToGenerator(regenerator.mark(function e(t, r, n) {
          var o, a, i, s;
          return regenerator.wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return e.next = 2, this.getAppPeriodData(t, r, n);
              case 2:
                if (0 !== (o = e.sent).length) {
                  e.next = 5;
                  break;
                }
                return e.abrupt("return", !0);
              case 5:
                return a = new Date(o[0].startDate).setHours(0, 0, 0, 0), i = new Date(o[0].endDate).setHours(0, 0, 0, 0), s = new Date().setHours(0, 0, 0, 0), e.abrupt("return", s >= a && s <= i);
              case 9:
              case "end":
                return e.stop();
            }
          }, e, this);
        }));
        return function (t, r, n) {
          return e.apply(this, arguments);
        };
      }()
    }], [{
      key: "getAppByLanguage",
      value: function value(e, t) {
        return t || (e === ENGLISH ? DIBELS8 : IDEL2);
      }
    }]), e;
  }();
exports.BMWindowClient = BMWindowClient;